import React from 'react'
import NewsComponent from '../components/NewsComponent'
import { sektorelGelismeler } from '../data/sektorel-gelismeler'



const SektorelGelismeler = () => {
    const title ='Sektörel Gelismeler'

    return (
        <div className=''>
            <NewsComponent data={sektorelGelismeler}  title={title}/>
        </div>
    )
}

export default SektorelGelismeler